export interface CounterSlice {
    count: number;
    increment: () => void;
    decrement: () => void;
}

export const createCounterSlice = (
    set: (fn: (state: CounterSlice) => CounterSlice) => void
): CounterSlice => ({
    count: 0,
    increment: () => set((state) => ({ ...state, count: state.count + 1 })),
    decrement: () => set((state) => ({ ...state, count: state.count - 1 })),
});
